class AuthService {
    constructor($http, $window, authUpgradedService, authStateService, cookieService, subscriptionService, logService) {
        this.$http = $http;
        this.$window = $window;
        this.authStateService = authStateService;
        this.cookieService = cookieService;
        this.authUpgradedService = authUpgradedService;

        this.logger = new LogServiceWrapper(logService, 'AuthService');

        this.authToken = '';

        this.rootSubscription = subscriptionService.createSubscription();
        this.subscribeToState();
    }

    getAuthToken() {
        return this.authToken || this.cookieService.get('aat');
    }

    processAuth() {
        if (this.tryGetTokenFromHash()) {
            return Promise.resolve();
        }

        return this.authUpgradedService
            .signIn()
            .then(user => {
                this.logger.log('processAuth', 'successfully authenticated in STS');
                this.authStateService.authToken = user.access_token;
                return Promise.resolve();
            })
            .catch(err => {
                this.logger.log('processAuth', 'unable to auth in STS', err);
                return Promise.reject();
            });
    }

    processElectronAuth() {
        if (this.tryGetTokenFromHash()) {
            return Promise.resolve();
        }

        if (!this.$window.preloadedApi.remote.getAuthToken) {
            this.logger.warn('processElectronAuth', 'getAuthToken is not defined');
            return Promise.reject();
        }

        return this.$window.preloadedApi.remote
            .getAuthToken()
            .then(token => {
                this.logger.log('processElectronAuth', 'successfully get auth token from Electron');
                this.authStateService.authToken = token;
                this.authUpgradedService.setupAuthTokenUpdatedSubscription();
                return Promise.resolve();
            })
            .catch(err => {
                this.logger.warn('processElectronAuth', 'unable to get auth token from Electron', err);
                return Promise.reject();
            });
    }

    subscribeToState() {
        this.rootSubscription.add(
            this.authStateService.authToken$.subscribe(next => {
                this.authToken = next;
                this.$http.defaults.headers.common.Authorization = 'Bearer ' + next;
            })
        );
    }

    tryGetTokenFromHash() {
        if (this.$window.location.hash.startsWith('#aat=')) {
            this.logger.log('tryGetTokenFromHash', 'successfully get auth token from url #hash');
            this.authStateService.authToken = window.location.hash.replace('#aat=', '');
            return true;
        }
        return false;
    }
}

firebird.service('authService', [
    '$http',
    '$window',
    'authUpgradedService',
    'authStateService',
    'cookieService',
    'subscriptionService',
    'logService',
    (...deps) => new AuthService(...deps)
]);
